import { __decorate } from "tslib";
import { Component, ViewEncapsulation, } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { UtilityService } from '../../../services/utility.service';
var DeleteRequestStep;
(function (DeleteRequestStep) {
    DeleteRequestStep[DeleteRequestStep["AreYouSure"] = 0] = "AreYouSure";
    DeleteRequestStep[DeleteRequestStep["Questionnaire"] = 1] = "Questionnaire";
    DeleteRequestStep[DeleteRequestStep["CustomReason"] = 2] = "CustomReason";
    DeleteRequestStep[DeleteRequestStep["EnterPhoneNumber"] = 3] = "EnterPhoneNumber";
    DeleteRequestStep[DeleteRequestStep["EnterOTP"] = 4] = "EnterOTP";
    DeleteRequestStep[DeleteRequestStep["Success"] = 5] = "Success";
})(DeleteRequestStep || (DeleteRequestStep = {}));
let DeleteRequestModalComponent = class DeleteRequestModalComponent {
    constructor(httpClient, router, sanitizer, utility, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.sanitizer = sanitizer;
        this.utility = utility;
        this.themeService = themeService;
        this.Step = DeleteRequestStep;
        this.successColor = '';
        this.backColor = '';
        this.errorColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.deleteRequestStep = this.Step.AreYouSure;
        this.lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
        this.selectedDropdownOption = '';
        this.selectedReason = null;
        this.customReasonText = '';
        this.activeOptions = false;
        this.questionnaire = [];
        this.questions = [];
        this.mobilePhone = '';
        this.oneTimePad = '';
        this.errorMessage = '';
        this.errorEmptyCustomReason = false;
        document.documentElement.style.overflowY = 'hidden';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
        this.httpClient.get('user/usermobilenumber').subscribe((data) => {
            this.mobilePhone = String(data);
        });
        this.httpClient.get('user/deleteaccountquestionnaire?language_name=' + this.lang).subscribe((data) => {
            this.questionnaire = data[0];
            this.questions = this.questionnaire.questionnaire.questions;
        });
    }
    close() {
        this.modal.destroy();
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
    openSelectOptions() {
        this.activeOptions = !this.activeOptions;
    }
    fillData(data) {
        this.errorEmptyCustomReason = false;
        this.selectedDropdownOption = data.language_value[0].value;
        this.selectedReason = data;
        if (data.customizable === 1) {
            this.deleteRequestStep = this.Step.CustomReason;
        }
        else {
            this.deleteRequestStep = this.Step.Questionnaire;
        }
        this.activeOptions = false;
    }
    confirmQuestionnaire() {
        if ((this.selectedReason.customizable === 1) && (this.customReasonText.length === 0)) {
            this.errorEmptyCustomReason = true;
            return;
        }
        const answers = Array();
        const optionsAnswers = Array();
        const temp = {
            question_option_id: this.selectedReason.id,
            customizable_value: (this.selectedReason.customizable === 1) ? this.customReasonText : null
        };
        optionsAnswers.push(temp);
        const temp2 = {
            question_id: this.questions[0].id,
            options_answers: optionsAnswers
        };
        answers.push(temp2);
        const result = {
            questionnaire_id: this.questionnaire.questionnaire_id,
            answers,
            language_name: this.lang
        };
        this.httpClient.post('user/savedeleteaccountquestionnaire', result).subscribe((submissionData) => {
            const response = submissionData;
            if (response.success === true) {
                this.deleteRequestStep = this.Step.EnterPhoneNumber;
            }
        });
    }
    sendSMS() {
        this.httpClient.post('user/senddeleterequesttoken', {
            mobile_number: this.mobilePhone
        }).subscribe((data) => {
            this.errorMessage = '';
            this.deleteRequestStep = this.Step.EnterOTP;
        }, (error) => {
            this.errorMessage = 'ACCOUNT.DELETE.MAX_SMS_CODE_ATTEMPTS_ERROR';
            this.utility.resetTimer();
        });
    }
    checkToken() {
        if (this.validateToken()) {
            this.httpClient.post('user/checkdeleterequesttoken', {
                token: this.oneTimePad
            }).subscribe((data) => {
                this.errorMessage = '';
                this.deleteRequestStep = this.Step.Success;
            }, (error) => {
                this.errorMessage = 'ACCOUNT.DELETE.SMS_CODE_ERROR';
            });
        }
    }
    validateToken() {
        this.errorMessage = '';
        const token = this.oneTimePad;
        const regEx = /^[0-9]{6}$/;
        if (regEx.test(token) === false) {
            this.errorMessage = 'ACCOUNT.DELETE.SMS_CODE_VALIDATION_ERROR';
            return false;
        }
        else {
            return true;
        }
    }
    confirmDeletion() {
        this.deleteRequestStep = this.Step.Questionnaire;
    }
};
DeleteRequestModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: DomSanitizer },
    { type: UtilityService },
    { type: WebsiteThemeService }
];
DeleteRequestModalComponent = __decorate([
    Component({
        selector: 'ecd-delete-request-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./delete-request-modal.component.html")).default
    })
], DeleteRequestModalComponent);
export { DeleteRequestModalComponent };
